import { render } from "./GetStartedBrief.vue?vue&type=template&id=547864bd&scoped=true"
import script from "./GetStartedBrief.vue?vue&type=script&lang=js"
export * from "./GetStartedBrief.vue?vue&type=script&lang=js"

import "./GetStartedBrief.vue?vue&type=style&index=0&id=547864bd&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-547864bd"

export default script